var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"st-sid"},[_c('div',{staticClass:"table"},[_c('img',{attrs:{"src":require('/src/assets/img/odc/HSE-sub-team.png')}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }